import React from 'react'
import { Redirect, Route, RouteProps, useLocation } from 'react-router'
import { storageFactory } from 'storage-factory'
import { tokenStorage } from 'TokenStorage'

const ProtectedRoute: React.FC<
    RouteProps & { debeTenerDeclarante?: boolean }
> = ({ debeTenerDeclarante = false, ...routeProps }) => {

    const storage = storageFactory(() => localStorage)

    const accessToken = tokenStorage.getAccessToken()
    const userName = tokenStorage.getUserName()
    const declaranteSeleccionado = storage?.getItem('declaranteSeleccionado')

    if (!accessToken || !userName) {
        return (
            <Route {...routeProps}>
                <Redirect to="/login" />
            </Route>
        )
    }

    if (debeTenerDeclarante && !declaranteSeleccionado) {
        return (
            <Route {...routeProps}>
                <Redirect to="/selectDeclarante" />
            </Route>
        )
    }

    return <Route {...routeProps} />
}

export default ProtectedRoute

export const OnlyAnonymousRoute: React.FC<RouteProps> = props => {
    const accessToken = tokenStorage.getAccessToken()
    const userName = tokenStorage.getUserName()
    const location = useLocation()

    const params = new URLSearchParams(location.search)
    const token = params.get('token')

    if (token) {
        return <Route {...props} />
    }

    return accessToken && userName ? (
        <Route {...props}>
            <Redirect to="/" />
        </Route>                                      
    ) : (
        <Route {...props} />
    )
}